import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserEffects } from '../../state/user/user.effects';
import { SnackbarService } from '../../utilities/snackbar.service';
import { ISlideshowItem } from './slideshows.interface';

@Injectable({ providedIn: 'root' })
export class SlideshowService {
  constructor(
    private translate: TranslateService,
    private snackBar: SnackbarService,
  ) {}

  public extractAuthorizedItems(items: ISlideshowItem[], showWarningIfUnauthorized: boolean): ISlideshowItem[] {
    const userAuthIds = UserEffects.getUser().authorizations.dashboardIds;

    if (userAuthIds === -1) {
      return items;
    }

    const authorizedItems = items.filter((item) => {
      if (item.type === 'url') {
        return true;
      }

      return item.id !== undefined && item.type === 'dashboard' && userAuthIds.includes(item.id);
    });

    if (showWarningIfUnauthorized && authorizedItems.length !== items.length) {
      this.snackBar.open(this.translate.instant('page.slideshows.dashboardPermissionWarning'));
    }

    return authorizedItems;
  }
}
